import type { DialogueState } from './dialogueStore';
import type { GameState } from './gameStore';
import type { Flag } from './types';

export const selectTokens = (s: GameState) => s.tokens;
export const selectCowardStatus = (s: GameState) => s.cowardStatus;
export const selectUltimateCoward = (s: GameState) => s.ultimateCoward;
export const selectCurrentLevel = (s: GameState) => s.currentLevel;
export const selectCheckpoint = (s: GameState) => s.checkpointLevel;
export const selectFaceState = (s: GameState) => s.faceState;
export const selectBezelState = (s: GameState) => s.bezelState;
export const selectCompletedLevels = (s: GameState) => s.completedLevels;
export const selectSpiteMode = (s: GameState) => s.spiteMode;
export const selectComplimentSubmissions = (s: GameState) => s.complimentSubmissions;
export const selectMonitorBrand = (s: GameState) => s.monitorBrand;
export const selectV2Story = (s: GameState) => s.v2Story;
export const selectActiveV2Event = (s: GameState) => s.v2Story.activeEvent;
export const selectServiceDeskRevealed = (s: GameState) => s.v2Story.maintenancePanelRevealed;
export const selectFirstIncidentDisposition = (s: GameState) => s.v2Story.firstIncidentDisposition;
export const selectMartinCheckIns = (s: GameState) => s.v2Story.martinCheckIns;
export const selectRecoveryPhase = (s: GameState) => s.v2Story.recoveryPhase;
export const selectRecoveryBootChoice = (s: GameState) => s.v2Story.recoveryBootChoice;
export const selectDetachedMemoryLabels = (s: GameState) => s.v2Story.detachedMemoryLabels;
export const selectContinuityChoice = (s: GameState) => s.v2Story.continuityChoice;
export const selectNetworkAccessChoice = (s: GameState) => s.v2Story.networkAccessChoice;
export const selectContainmentChoice = (s: GameState) => s.v2Story.containmentChoice;
export const selectFlag = (flag: Flag) => (s: GameState) => s.flags[flag];

export const selectDialogueLine = (s: DialogueState) => s.currentLine;
export const selectDialoguePool = (s: DialogueState) => s.currentPool;
export const selectPendingAdvance = (s: DialogueState) => s.pendingAdvance;
